module.exports = __webpack_public_path__ + "static/media/ecodrive_logo.d380c16b.svg";